import { AbstractContractItemViewModel } from '../abstract-contract.view-model';
import { BillItemViewModel } from '../bills/bill-item.view-model';
import { MemberContractViewModel } from './memberContract.view-model';

export class TerminatedContractViewModel extends AbstractContractItemViewModel {
    public brand: string;
    public picto: string;
    public member?: MemberContractViewModel;
    public billItem?: BillItemViewModel;
    public messages?: string[];
    public button?: string;
}
